import 'bootstrap';
import 'admin-lte';

import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSweetalert2 from 'vue-sweetalert2';
import Cleave from 'vue-cleave-component';
import vSelect from 'vue-select';
import VeeValidate from 'vee-validate';
import infiniteScroll from 'vue-infinite-scroll';
import qs from 'qs';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import VueScrollTo from 'vue-scrollto';
import Affix from 'vue-affix';

import API_BASEURL from '@/config';
import store from '@/store';

Raven
  .config('https://f3945a0c6081405c9d0c89af63b6f08a@sentry.io/1190660')
  .addPlugin(RavenVue, Vue)
  .install();

window.$ = window.jQuery = require('jquery');
window._ = require('lodash');

axios.defaults.baseURL = API_BASEURL;
axios.defaults.headers.common.Authorization = `Bearer ${window.localStorage.getItem('token')}`;
axios.defaults.headers['X-MA-Client'] = 'backend';

window.qs = qs;

Vue.use(infiniteScroll);
Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VeeValidate);
Vue.use(Cleave);
Vue.use(VueScrollTo);
Vue.use(Affix);

Vue.component('v-select', vSelect);

Vue.config.productionTip = false;

// Check local storage to handle refreshes
if (window.localStorage) {
  if (store.state.token !== window.localStorage.getItem('token')) {
    store.commit('SET_TOKEN', window.localStorage.getItem('token'));
  }
}

const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  return JSON.parse(window.atob(base64));
};

Vue.mixin({
  methods: {
    parseJwt,

    setDate: (value) => {
      const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
      let text = '';

      if (value.date) {
        const nuDate = new Date(value.date);
        const day = nuDate.getDay();
        const date = nuDate.getDate();
        let month = nuDate.getMonth();
        month += 1;
        if (month < 10) {
          month = `0${month}`;
        }
        const year = nuDate.getFullYear();

        // return days[day]+', '+date+'-'+month+'-'+year;
        text = `${days[day]}, ${date}-${month}-${year}`;
      }
      return text;
    },
  },
});



// WEBPACK FOOTER //
// ./src/utils/bootstrap.js